import { Button, Modal } from "react-bootstrap";
import { reasonsForStep } from "../../utils/slaReasons.js";

// The uniform Out-Of-Target reason picker. Extracted from the SLA report so the
// SLA report AND the Progress screen select the reason the SAME way (Robert
// 2026-07-25 — "make that a thing for this sort of selection so it's uniform").
// Reasons render as a vertical stack of colour-coded buttons:
//   green  = excuses the overrun (counts as acceptable)
//   red    = claims' fault
// `current` is the currently-selected reason TEXT — it highlights the matching
// button and reveals the "Clear reason" action.
// `columnKey` is the SLA step being excused. Its own reasons (1.0 wrote each
// phrase for one step, sla.md) come FIRST; every other reason follows under
// a divider, so the full list is always there — the first cut of the step
// filter (2026-09-11 morning) hid the rest, and KS noticed within the hour:
// "it's not showing the total list anymore".
export default function ReasonPickerModal({
  show,
  title,
  reasons,
  columnKey = null,
  current = "",
  onSelect,
  onClear,
  onHide,
}) {
  const all = reasons || [];
  const forStep = columnKey ? reasonsForStep(all, columnKey) : all;
  const others = columnKey ? all.filter((r) => !forStep.includes(r)) : [];
  const button = (r) => (
    <Button
      key={r.id}
      size="sm"
      variant={
        current === r.reason
          ? r.is_claims_fault
            ? "danger"
            : "success"
          : r.is_claims_fault
            ? "outline-danger"
            : "outline-success"
      }
      className="text-start"
      onClick={() => onSelect(r.id)}
    >
      {r.reason}
    </Button>
  );
  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title className="h6">{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="d-grid gap-1">
          {forStep.map(button)}
          {others.length > 0 ? (
            <div className="small text-muted text-uppercase fw-semibold mt-2 pt-2 border-top" style={{ letterSpacing: ".04em", fontSize: ".7rem" }}>
              Other steps&apos; reasons
            </div>
          ) : null}
          {others.map(button)}
          {current ? (
            <Button size="sm" variant="outline-secondary" onClick={onClear}>
              Clear reason
            </Button>
          ) : null}
        </div>
        <div className="small text-muted mt-2">
          Green reasons excuse the overrun (counts as acceptable) · red reasons are claims&apos; fault.
        </div>
      </Modal.Body>
    </Modal>
  );
}
